<template>
  <div class="page">
    <h2 class="title">猩号炒群</h2>
    <div class="search-line">
      <div class="normal">
        选择群聊：
        <el-select
          v-model="group_id"
          filterable
          placeholder="选择群聊"
          default-first-option
          :remote-method="searchGroup"
          remote
          class="search"
        >
          <el-option
            v-for="item in groupSearchResult"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button type="primary" v-if="group_id" @click="deleteGroup"
          >删除</el-button
        >
      </div>
    </div>

    <div>
      <div style="display: inline-block;">
        <el-input
          type="textarea"
          v-model="words"
          placeholder="聊天内容"
          cols="40"
          rows="5"
          resize="none"
          style="font-size: 18px;"
        ></el-input>
      </div>
    </div>
    <div>
      <div class="normal"><input type="file" @change="chooseImage" /></div>
      <div class="imageBox">
        <div v-for="(img, index) in images" :key="index" class="imageItem">
          <img :src="img" preview="1" />
          <button @click="delImage(index);">删除</button>
        </div>
      </div>
    </div>
    <div>
      <el-select v-model="user_way">
        <el-option
          v-for="way in ['随机用户', '当前用户']"
          :key="way"
          :label="way"
          :value="way"
        >
        </el-option>
      </el-select>
      当前用户：{{ currentUser.nickname || "" }}
    </div>
    <div class="normal">
      <el-button type="primary" @click="sendMessage">发送</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      group_id: "",
      groupSearchResult: [],
      words: "",
      images: [],
      user_way: "当前用户",
      currentUser: {}
    };
  },
  methods: {
    searchGroup(search) {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "xinghao/searchGroup", {
          params: {
            keyword: search
          }
        })
        .then(res => {
          that.groupSearchResult = res.data.data;
        });
    },

    delImage(index) {
      this.images.splice(index, 1);
    },

    chooseImage(event) {
      // 上传图片
      let that = this;
      let origin = event.target.id;
      let option = {
        file: event.target.files[0],
        head_name: "xinghao_msg"
      };
      that
        .$uploadImage(option)
        .then(function(res) {
          console.log("upload back", res);
          if (!res) {
            console.log("upload fail");
            return false;
          }
          if (res === "图片太大") {
            that.$message.error("图片太大了");
            return false;
          }
          let img_url = res;
          that.images.push(img_url);
          that.$previewRefresh();
        })
        .catch(function(res) {
          console.log("upload fail", res);
        });
    },

    sendMessage() {
      let that = this;
      if (!that.group_id) {
        that.$message.error("请选择群聊");
        return;
      }
      let words = that.words.trim();
      let image = that.images[0];
      if (!words && !image) {
        that.$message.error("内容为空");
        return;
      }
      let content = words;
      let msgType = "文字";
      if (!content) {
        content = image;
        msgType = "图片";
      }
      let params = {
        group_id: that.group_id,
        content: content,
        msgType: msgType,
      };
      if (that.user_way === "当前用户" && that.currentUser.id) {
        params.user_id = that.currentUser.id;
      }
      that.$axios
        .post(that.$url_prefix + "xinghao/fire/sendMessage", params)
        .then(res => {
          if (res.data.success) {
            that.images = [];
            that.words = "";
            if (res.data.user) {
              that.currentUser = res.data.user;
            }
            that.$message({
              type: "success",
              message: "发送成功"
            });
          } else {
            that.$message.error("发送失败");
          }
        });
    },

    deleteGroup() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "xinghao/chat/delete", {
          params: {
            chat_id: that.group_id
          }
        })
        .then(res => {
          if (res.data.success) {
            that.$message({
              type: "success",
              message: "删除成功"
            });
            that.group_id = "";
            that.groupSearchResult = [];
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          that.$message.error("删除失败");
        });
    }
  }
};
</script>

<style scoped>
.page {
  text-align: center;
  overflow: hidden;
}
.title {
  margin-top: 50px;
}
.search-line {
  margin-top: 50px;
}
.search {
  width: 400px;
}
.imageBox {
  margin: 20px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.imageBox .imageItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
}
img {
  height: 100px;
  width: 100px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/page/FireGroup.vue